import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getAvailablePoints } from '../../../api/rewards.api';

const RewardPointsSection: React.FC = () => {
  const navigate = useNavigate();

  const { data: availablePointsRes } = useQuery({
    queryKey: ['getAvailablePoints', 'aye'],
    queryFn: () => getAvailablePoints('aye'),
    enabled: Boolean(localStorage.getItem('ayeAdminEntityId')),
    retry: 3,
    refetchOnWindowFocus: false
  });

  const available_points =
    availablePointsRes?.success && availablePointsRes?.data?.points
      ? availablePointsRes.data.points
      : 0;

  return (
    <div className="mx-auto mt-8 max-w-full px-4 pb-6 sm:px-6 lg:px-8">
      <section>
        <h1 className="text-lg font-semibold leading-6 text-gray-900">
          Ayeface Rewards
        </h1>
        <div className="flex flex-wrap items-center justify-between">
          <div className="flex flex-nowrap gap-1">
            <p>You have</p>
            <h2 className="text-lg font-bold leading-6 text-gray-600">
              {available_points}
            </h2>
            <p>AyeFace Points</p>
          </div>
          <button
            className="rounded-full bg-white px-5 py-2 shadow-lg"
            onClick={() => {
              navigate('/my-rewards-hub/aye');
            }}
          >
            <p className="bg-gradient-to-r from-[#F76443] to-[#FEC745] bg-clip-text text-transparent">
              See More
            </p>
          </button>
        </div>
      </section>
    </div>
  );
};

export default RewardPointsSection;
